const AppActionEnum = {
  ALL: 1,
  FIRST_CREATE: 2,
  STATUS: 3,
  NAME: 10,
  SHORT_DESCRIPTION: 11,
  LONG_DESCRIPTION: 12,
  CATEGORY: 13,
  RATE: 14,
  AGE_RATING: 15,
  AGE_GROUP_IMAGE_URL: 16,
  REVIEWS_COUNT: 17,
  DOWNLOAD_COUNT: 18,
  ICON_URL: 19,
  HAS_VIDEO: 21,
  VIDEO_LINK: 22,
  HAS_SCREENSHOTS: 23,
  SCREENSHOTS: 24,
  WHATS_NEW: 25,
  VERSIONS: 26,
  SIZE: 27,
  LANGUAGES: 28,
  COPYRIGHT: 29,
  PRICE: 30,
  COMPATIBILITY: 31,
  IN_APP_PURCHASES: 32,
  SUPPORTS: 33,
  UPDATED_ON: 34,
  DEVELOPER: 35,
  RELEASED_ON: 36,

  nameMap: {
    [1]: 'All',
    [2]: 'First Create',
    [3]: 'Status',
    [10]: 'Name',
    [11]: 'Short Description',
    [12]: 'Long Description',
    [13]: 'Category',
    [14]: 'Rate',
    [15]: 'Age Rating',
    [16]: 'Age Group',
    [17]: 'Reviews Count',
    [18]: 'Download Count',
    [19]: 'Icon',
    [21]: 'Has Video',
    [22]: 'Video Link',
    [23]: 'Has Screenshots',
    [24]: 'Screenshots',
    [25]: 'What\'s New',
    [26]: 'Versions',
    [27]: 'Size',
    [28]: 'Languages',
    [29]: 'Copyright',
    [30]: 'Price',
    [31]: 'Compatibility',
    [32]: 'In-App Purchases',
    [33]: 'Supports',
    [34]: 'Updated On',
    [35]: 'Developer',
    [36]: 'Released On',
  },

  cases() {
    return {
      [this.ALL]: 'All',
      [this.FIRST_CREATE]: 'First Create',
      [this.STATUS]: 'Status',
      [this.NAME]: 'Name',
      [this.SHORT_DESCRIPTION]: 'Short Description',
      [this.LONG_DESCRIPTION]: 'Long Description',
      [this.CATEGORY]: 'Category',
      [this.RATE]: 'Rate',
      [this.AGE_RATING]: 'Age Rating',
      [this.AGE_GROUP_IMAGE_URL]: 'Age Group',
      [this.REVIEWS_COUNT]: 'Reviews Count',
      [this.DOWNLOAD_COUNT]: 'Download Count',
      [this.ICON_URL]: 'Icon',
      [this.HAS_VIDEO]: 'Has Video',
      [this.VIDEO_LINK]: 'Video Link',
      [this.HAS_SCREENSHOTS]: 'Has Screenshots',
      [this.SCREENSHOTS]: 'Screenshots',
      [this.WHATS_NEW]: 'What\'s New',
      [this.VERSIONS]: 'Versions',
      [this.SIZE]: 'Size',
      [this.LANGUAGES]: 'Languages',
      [this.COPYRIGHT]: 'Copyright',
      [this.PRICE]: 'Price',
      [this.COMPATIBILITY]: 'Compatibility',
      [this.IN_APP_PURCHASES]: 'In-App Purchases',
      [this.SUPPORTS]: 'Supports',
      [this.UPDATED_ON]: 'Updated On',
      [this.DEVELOPER]: 'Developer',
      [this.RELEASED_ON]: 'Released On',
    };
  },

  isValidId(id) {
    return Object.values(this.cases()).includes(id);
  },

  fromId(id) {
    return this.cases()[id] || null;
  },

  toId(name) {
    const cases = this.cases();
    return Object.keys(cases).find(key => cases[key] === name) || null;
  },

  ids() {
    return Object.keys(this.cases());
  },

  names() {
    return Object.values(this.cases());
  },

  getNameById(id) {
    return this.nameMap[id] || null;
  },

  getAllOptions(includeAll = false, includeFirstCreate = false) {
    let options =  Object.entries(this.cases()).map(([id, name]) => ({
      id: Number(id),
      name,
    }));
    if (!includeAll) {
      options = options.filter(option => option.name !== 'All');
    }
    if (!includeFirstCreate) {
      options =  options.filter(option => option.name !== 'First Create');
    }
    return options;
  },

  getFilterOptions() {
    const filterIds = [
      this.CATEGORY,
      this.DEVELOPER,
      this.HAS_VIDEO,
      this.ICON_URL,
      this.LONG_DESCRIPTION,
      this.NAME,
      this.SCREENSHOTS,
      this.SHORT_DESCRIPTION,
      this.STATUS,
      this.VIDEO_LINK,
    ];
    return filterIds.map(id =>({
      id,
      name: this.getNameById(id),
    }));
  },
};

export default AppActionEnum;
